module.exports = __webpack_public_path__ + "static/media/top2.bfac583d.jpg";